import { Injectable } from '@angular/core';
import { ObjectWalkService } from '@ispm/shared/services/object-walk.service';
import _ from 'lodash';

@Injectable()
export class ReassignModalService {

  constructor(
    public objectWalkService: ObjectWalkService,
  ) { }

    setReadOnlyModeParameters(readOnlyModeDesc: any, readOnlySource: any, readOnlyTarget: any): any {
        let readOnlyParameters: any;
        readOnlyParameters = { };
        if (readOnlyModeDesc) {
            const source = _.get(readOnlyModeDesc, 'source', undefined);
            const target = _.get(readOnlyModeDesc, 'target', undefined);
            readOnlyParameters.source = source && readOnlySource ? this.objectWalkService.walk(readOnlySource, source) : undefined;
            readOnlyParameters.target = target && readOnlyTarget ? this.objectWalkService.walk(readOnlyTarget, target) : undefined;
            if (readOnlyParameters.target && readOnlyParameters.target.length > 0) {
                const targetOfTargets = _.get(readOnlyModeDesc, 'targetOfTargets', undefined);
                readOnlyParameters.target = this.objectWalkService.walk(readOnlyParameters.target, targetOfTargets);
            }
            const practitionerFilterBySearchParam = _.get(readOnlyModeDesc, 'filterBy', undefined);
            if (practitionerFilterBySearchParam && readOnlyParameters.source) {
                readOnlyParameters.practitionerFilterBy = { };
                readOnlyParameters.practitionerFilterBy[practitionerFilterBySearchParam] = readOnlyParameters.source;
            }
        }
        return readOnlyParameters;
    }

    reassignIsEnabled(readOnlyParameters: any): any {
        if (readOnlyParameters && readOnlyParameters.source && readOnlyParameters.target) {
        const target = readOnlyParameters.target[0];
        const srcString = readOnlyParameters.source.toString().toLowerCase();
        const intersection = !_.isEmpty(target) ?
            target.find(prop => prop.toString().toLowerCase() === srcString) : undefined;
        return intersection !== undefined;
        }
        return true;
    }

  isAdminHasPermissionToReassign(userData) {
    return userData.isAdmin
      && userData.permissions.includes('ADMIN.ORGANIZATION.WORKLIST')
      && userData.permissions.includes('ADMIN.ORGANIZATION.WORKLIST.CREATE');
  }
}
